export default {"src":"/_next/static/media/PotraitButton.27481564.svg","height":44,"width":23,"blurWidth":0,"blurHeight":0};